import React from 'react';
import {
  tickColor,

} from './Utils';

interface IProps {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  color?: string;
}

const lineThickness = 1;

export default class extends React.Component<IProps, {}> {
  render() {
    const {x1, y1, x2, y2, color} = this.props;
    const stroke = (color === undefined) ? tickColor : color;
    return (
      <line
        x1={x1} y1={y1} x2={x2} y2={y2}
        strokeWidth={lineThickness} stroke={stroke}
      />
    );
  }
}
